// 签约状态
export const signStatusMap = {
  none: '未签约',
  valid: '已签约',
  restrictValid: '受限生效',
  audit: '审核中',
  waitConfirm: '待商户确认协议',
  auditReject: '审核未通过',
  invalid: '合约失效',
  restrictInvalid: '受限失效',
  fail: '接口错误',

  '未签约': 'none',
  '已签约': 'valid',
  '受限生效': 'restrictValid',
  '审核中': 'audit',
  '待商户确认协议': 'waitConfirm',
  '审核未通过': 'auditReject',
  '合约失效': 'invalid',
  '受限失效': 'restrictInvalid',
  '接口错误': 'fail',

  fulldesc: {
    none: '未签约，表示还没有签约该产品',
    valid: '已签约，表示合约已经生效，不需要再签约了',
    restrictValid: '受限生效，表示合约已经生效，但是资料不全，功能受限',
    audit: '审核中，已经有合约在审核中，请等待审核完成',
    waitConfirm: '待商户确认协议，合约已经审核通过，需要商户确认后合约才生效',
    auditReject: '审核未通过',
    invalid: '合约失效，曾经签过合约，但已经失效了，可以重新发起签约',
    restrictInvalid: '受限失效，受限合约失效了',
    fail: '接口错误',
  },
}

// 提现类型
export const withdrawTypeMap = {
  1: '自行发放',
  2: '支付宝发放',

  '自行发放': 1,
  '支付宝发放': 2,
}

